import { createSlice } from "@reduxjs/toolkit";

// Get language from localStorage or default to "en"
const getInitialLanguage = () => {
  try {
    const savedLang = localStorage.getItem("naahelcyber-lang");
    return savedLang === "en" ? "en" : "ar";
  } catch (error) {
    return "ar";
  }
};

const initialState = {
  lang: getInitialLanguage(), // "en" or "ar"
};

const i18nSlice = createSlice({
  name: "i18n",
  initialState,
  reducers: {
    setLanguage(state, action) {
      const newLang = action.payload === "ar" ? "ar" : "en";
      state.lang = newLang;
      // Persist to localStorage
      try {
        localStorage.setItem("naahelcyber-lang", newLang);
      } catch (error) {
        console.warn("Failed to save language to localStorage:", error);
      }
    },
    toggleLanguage(state) {
      const newLang = state.lang === "en" ? "ar" : "en";
      state.lang = newLang;
      // Persist to localStorage
      try {
        localStorage.setItem("naahelcyber-lang", newLang);
      } catch (error) {
        console.warn("Failed to save language to localStorage:", error);
      }
    },
  },
});

export const { setLanguage, toggleLanguage } = i18nSlice.actions;
export default i18nSlice.reducer;
